import { productList } from "constants/product";
import * as API from "../API/index";
import { authorizedUser } from "components/CommonComponent/CommonFunction";

export const addProduct = async (bodyData) => {
  try {
    const res = await API.add_product(bodyData);
    return res?.data;
  } catch (error) {
    authorizedUser(error.response?.data);
    return error?.response?.data || error;
  }
};

export const getProductList = async (dispatch, pageNum, filters) => {
  try {
    const res = await API.product_list(pageNum, filters);
    dispatch({ type: productList, payload: res?.data });
  } catch (error) {
    authorizedUser(error.response?.data);
    dispatch({
      type: productList,
      payload: error?.response?.data || error,
    });
  }
};

export const getProductById = async (id) => {
  try {
    const res = await API.get_product_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const updateProductById = async (id, bodyData) => {
  try {
    const res = await API.edit_product(id, bodyData);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
};

export const deleteProductById = async (id) => {
  try {
    const res = await API.delete_product_by_ID(id);
    return res?.data;
  } catch (error) {
    return error?.response?.data || error;
  }
}